// extracted by mini-css-extract-plugin
export const toasts = "Toasts-module--toasts--208_L";
export const toast = "Toasts-module--toast--3WHVB";
export const fadeOut = "Toasts-module--fadeOut--3ewJ6";